import { Box, Container, Typography, Button, Paper } from '@mui/material';
import { motion } from 'framer-motion';

const FinalCTA = () => {
  return (
    <Box sx={{ py: 8, bgcolor: 'primary.main', color: 'white' }}>
      <Container maxWidth="md">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            component="h2"
            variant="h3"
            align="center"
            gutterBottom
            sx={{ mb: 4 }}
          >
            Are You Ready to Build Your Tax Preparation Business?
          </Typography>

          <Typography variant="h6" align="center" paragraph sx={{ mb: 4 }}>
            The tax industry is full of opportunity, and now is the perfect time to start your own business.
          </Typography>

          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 4, mb: 6 }}>
            <Paper elevation={3} sx={{ p: 3, bgcolor: 'background.paper', color: 'text.primary' }}>
              <Typography variant="h6" gutterBottom>
                Start-Up Package
              </Typography>
              <Typography variant="h4" color="primary" gutterBottom>
                $495
              </Typography>
              <Typography variant="body2" sx={{ mb: 2 }}>
                Ideal for beginners who want to build their foundation the right way.
              </Typography>
              <a href="https://square.link/u/i7fWrZGk" style={{color: 'inherit', textDecoration: 'none'}} target="_blank">
                <Button 
                  variant="contained" 
                  color="primary"
                  fullWidth
                  sx={{ 
                    mt: 2,
                    '&:hover': {
                      transform: 'scale(1.05)',
                      transition: 'transform 0.2s ease-in-out',
                    }
                  }}
                >
                  Get Started Now
                </Button>
              </a>
            </Paper>

            <Paper elevation={3} sx={{ p: 3, bgcolor: 'background.paper', color: 'text.primary' }}>
              <Typography variant="h6" gutterBottom>
                Business Package
              </Typography>
              <Typography variant="h4" color="primary" gutterBottom>
                $1,995
              </Typography>
              <Typography variant="body2" sx={{ mb: 2 }}>
                For those ready to scale with advanced strategies and tools.
              </Typography>
              <a href="https://square.link/u/Hm586voQ" style={{color: 'inherit', textDecoration: 'none'}} target="_blank">
                <Button 
                  variant="contained" 
                  color="secondary"
                  fullWidth
                  sx={{ 
                    mt: 2,
                    '&:hover': {
                      transform: 'scale(1.05)',
                      transition: 'transform 0.2s ease-in-out',
                    }
                  }}
                >
                  Scale Your Business
                </Button>
              </a>
            </Paper>
          </Box>

          <Paper 
            elevation={2} 
            sx={{ 
              p: 3, 
              bgcolor: 'rgba(255, 255, 255, 0.1)',
              color: 'white',
              borderRadius: 2
            }}
          >
            <Typography variant="h6" align="center" gutterBottom>
              Important: No-Refund Policy
            </Typography>
            <Typography align="center" variant="body2">
              Due to the nature of the digital products and services provided, we are unable to offer refunds once the purchase is made. 
              By purchasing any of the packages, you agree to this policy. However, I'm committed to your success and will provide you 
              with all the resources and support needed to ensure you're on the right track.
            </Typography>
          </Paper>
        </motion.div>
      </Container>
    </Box>
  );
};

export default FinalCTA;
